import { IAPISParty } from "@vmosolutions/oc-interfaces";
import { Auth, API } from "aws-amplify";

export const getAPISRules = async (): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const apisRules = await API.get("skytrains", "/apisRules", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });
    return apisRules;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getAPISParties = async (): Promise<IAPISParty[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  try {
    const results = await API.get("skytrains", "/APIS", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });
    return results;
  } catch (error) {
    return null;
  }
};
